<template>
    <div class="main2" v-if="main_show">
        <!-- <el-tabs type="border-card" v-model="invoice_index" @tab-click="tabs_change">
            <el-tab-pane v-for="(item,i) in invoice_list" :key="i" :label="'第'+Number(i+1)+'张'"></el-tab-pane>
        </el-tabs> -->

        <!-- {{ invoice_list }} -->
        <Carousel v-model="carousel_value" arrow="always">
            <CarouselItem v-for="(invoice_item, invoice_index) in invoice_list" :key="invoice_index"
                class="CarouselItem">
                <!-- <Alert style="margin-top:10px" v-if="invoice_item.invoice_status == 2" type="error">当前这张发票已经作废</Alert> -->

                <div class="invoicMain_box">
                    <div class="invoicMain">
                        <div class="del_icon" v-if="del_show" @click="click_del(invoice_index)">
                            <Icon type="ios-trash-outline" size="18" />删除
                        </div>
                        <!-- head start -->
                        <div class="invoiceHeader">
                            <div class="headerLeft">
                                <div class="qrcode_template">
                                    二维码
                                    <!-- <img src="@/assets/image/finance/qrcode.png" width="83" height="83" alt=""> -->
                                </div>
                                <div class="jiqima">
                                    <p class="fapiaohao"></p>
                                    <div class="color_text ">
                                        <!-- <div>机器编号：</div> -->
                                    </div>
                                </div>
                            </div>
                            <span v-if="invoice_item.invoice_status == 2"
                                class="iconfont iconzuofei zuofei_icon"></span>
                            <div class="headerMiddle">
                                <span class="hedaer_title">电子发票（{{ invoice_item.invoice_type == 0 ? '普通发票' :
                                    '专用发票'
                                    }}）</span>
                                <div class="line"></div>
                            </div>
                            <div>
                                <img src="@/assets/image/finance/zhang.png" class="zhang_img" alt="" />
                            </div>
                            <div class="headerRight">
                                <!-- <p class="noid">№<span class="c-red"></span></p> -->
                                <div class="fapiaohaoma">发票号码：<span class="fapiaohaoma_span">以实际为准</span> </div>
                                <div class="fapiaohaoma">开票日期：<span class="fapiaohaoma_span">以实际为准</span></div>
                                <!-- <p class="color_text"><label>开票日期：</label><span>以实际开出为准</span></p> -->
                            </div>
                        </div>
                        <!-- head end -->
                        <!-- invoice body start -->
                        <div class="invoiceBody">
                            <div class="userInfo">
                                <div class="buy">购买方</div>
                                <ul class="color_text">
                                    <li class="khh_txt">
                                        <label class="khh_txt_title">名&nbsp;&nbsp;&nbsp;&nbsp;称：</label><span
                                            class="f-small">{{
                                                invoice_item.project_subject_info.company_name }}</span>
                                    </li>
                                    <li class="khh_txt">
                                        <label class="khh_txt_title">纳税人识别号：</label><span class="f-big">{{
                                            invoice_item.project_subject_info.tax_num
                                            }}</span>
                                    </li>
                                    <li class="khh_txt">
                                        <div class="location_div">
                                            <label class="location_title">地址、&nbsp;电话：</label>
                                            <div class="f-small2-1 color_text">
                                                {{ invoice_item.project_subject_info.company_place }}{{
                                                    invoice_item.project_subject_info.company_phone }}
                                            </div>
                                        </div>
                                    </li>
                                    <li class="khh_txt">
                                        <label class="khh_txt_title">开户行及账号：</label><span class="f-small2-1">{{
                                            invoice_item.project_subject_info.bank_name }}
                                            {{ invoice_item.project_subject_info.bank_num }}</span>
                                    </li>
                                </ul>
                                <div class="password">销售方</div>
                                <ul>
                                    <li class="khh_txt">
                                        <label class="khh_txt_title">名&nbsp;&nbsp;&nbsp;&nbsp;称：</label><span
                                            class="f-small color_text">{{
                                                invoice_item['subject_info']['company_name']
                                            }}</span>
                                    </li>
                                    <li class="khh_txt">
                                        <label class="khh_txt_title">纳税人识别号：</label><span class="f-big color_text">{{
                                            invoice_item['subject_info']['duty_paragraph'] }}</span>
                                    </li>
                                    <li class="khh_txt">
                                        <div class="location_div">
                                            <label class="location_title">地址、&nbsp;电话：</label>
                                            <div class="f-small2-1 color_text">{{
                                                invoice_item['subject_info']['location'] }}{{
                                                    invoice_item['subject_info']['phone'] }}
                                            </div>
                                        </div>

                                    </li>
                                    <li class="khh_txt">
                                        <label class="khh_txt_title">开户行及账号：</label><span class="f-small2-1 color_text">
                                            -- </span>
                                    </li>
                                </ul>

                                <!-- <div class="pwdInfo">
                                     <ul>
                                        <li class="khh_txt">
                                            <label class="khh_txt_title">名&nbsp;&nbsp;&nbsp;&nbsp;称：</label><span
                                                class="f-small color_text">{{
                                                    invoice_item['subject_info']['company_name']
                                                }}</span>
                                        </li>
                                        <li class="khh_txt">
                                            <label class="khh_txt_title">纳税人识别号：</label><span
                                                class="f-big color_text">{{
                                                    invoice_item['subject_info']['duty_paragraph'] }}</span>
                                        </li>
                                        <li class="khh_txt">
                                            <div class="location_div">
                                                <label class="location_title">地址、&nbsp;电话：</label>
                                                <div class="f-small2-1 color_text">{{
                                                    invoice_item['subject_info']['location'] }}{{
                                                        invoice_item['subject_info']['phone'] }}
                                                </div>
                                            </div>

                                        </li>
                                        <li class="khh_txt">
                                            <label class="khh_txt_title">开户行及账号：</label><span
                                                class="f-small2-1 color_text">
                                                -- </span>
                                        </li>
                                    </ul>
                                    <span class="f-big color_text">{{ rand_mima() }}</span> 
                                
                                </div> -->
                            </div>
                            <div>
                                <table class="GoodsTable" cellpadding="0" cellspacing="0">
                                    <thead>
                                        <tr>
                                            <td style="width: 24%">货物或应税劳务、服务名称</td>
                                            <td style="width: 10%">规格型号</td>
                                            <td style="width: 7%">单位</td>
                                            <td style="width: 10%">数 量</td>
                                            <td style="width: 10%">单 价</td>
                                            <td style="width: 16%">金 额</td>
                                            <td style="width: 7%">税率</td>
                                            <td style="width: 16%; border-right: none;">税 额</td>
                                        </tr>
                                    </thead>
                                    <tbody class="invoice-list" style="" v-if="invoice_list[invoice_index]">
                                        <tr v-for="(table_data, table_index) in invoice_list[invoice_index]['tax_rate_list']"
                                            :key="table_index">
                                            <!-- {{ table_data }} -->
                                            <td>
                                                <div class="goods_text color_text">{{ table_data.project_name }}</div>
                                            </td>
                                            <td>
                                                <div class="goods_text color_text">-</div>
                                            </td>
                                            <td>
                                                <div class="goods_text color_text">件</div>
                                            </td>
                                            <td>
                                                <div class="goods_text color_text">{{ table_data.count }}</div>
                                            </td>
                                            <td>
                                                <div class="goods_text color_text">{{ table_data.unit_price }}</div>
                                            </td>
                                            <td>
                                                <div class="goods_text color_text">{{ table_data.price }}</div>
                                            </td>
                                            <td>
                                                <div class="goods_text color_text">{{ table_data.tex_rate }}%</div>
                                            </td>
                                            <td>
                                                <div class="goods_text color_text">{{ table_data.tax }}</div>
                                            </td>
                                        </tr>
                                        <tr v-for="i in (8 - (invoice_list[invoice_index]['tax_rate_list'].length))"
                                            :key="i">
                                            <td>
                                                <div class="goods_text color_text"></div>
                                            </td>
                                            <td>
                                                <div class="goods_text color_text"></div>
                                            </td>
                                            <td>
                                                <div class="goods_text color_text"></div>
                                            </td>
                                            <td>
                                                <div class="goods_text color_text"></div>
                                            </td>
                                            <td>
                                                <div class="goods_text color_text"></div>
                                            </td>
                                            <td>
                                                <div class="goods_text color_text"></div>
                                            </td>
                                            <td>
                                                <div class="goods_text color_text"></div>
                                            </td>
                                            <td>
                                                <div class="goods_text color_text"></div>
                                            </td>
                                        </tr>

                                    </tbody>

                                    <tfoot>
                                        <tr class="total">
                                            <td>合 &nbsp;&nbsp;&nbsp;计</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td><span class="rmb">￥</span>
                                                <span class="rmb2">{{ invoice_list[invoice_index]['total_price']
                                                    }}</span>
                                            </td>
                                            <td></td>
                                            <td><span class="rmb">￥</span>
                                                <span class="rmb2">{{ invoice_list[invoice_index]['total_tax']
                                                    }}</span>
                                            </td>

                                        </tr>
                                        <tr class="GoodsTotal">
                                            <td>价税合计(大写)</td>
                                            <td colspan="7">
                                                <div style="width: 100%;display:flex">
                                                    <div class="color_text" type="text" style="width: 60%"><span
                                                            class='color_text c-black'>
                                                            ⓧ
                                                            {{ changeToChinese(invoice_item['total_money'])
                                                            }}</span>
                                                    </div>

                                                    <div type="text" class="color_text" style="width: 30%"> (小写) <span
                                                            class='c-black color_text'><span
                                                                class="rmb color_text">￥</span>{{
                                                                    invoice_item['total_money'] }}</span>
                                                    </div>
                                                </div>

                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                                <div class="">
                                    <!-- <div class="buy">销售方</div> -->
                                    <!-- <ul>
                                        <li class="khh_txt">
                                            <label class="khh_txt_title">名&nbsp;&nbsp;&nbsp;&nbsp;称：</label><span
                                                class="f-small color_text">{{
                                                    invoice_item['subject_info']['company_name']
                                                }}</span>
                                        </li>
                                        <li class="khh_txt">
                                            <label class="khh_txt_title">纳税人识别号：</label><span
                                                class="f-big color_text">{{
                                                    invoice_item['subject_info']['duty_paragraph'] }}</span>
                                        </li>
                                        <li class="khh_txt">
                                            <div class="location_div">
                                                <label class="location_title">地址、&nbsp;电话：</label>
                                                <div class="f-small2-1 color_text">{{
                                                    invoice_item['subject_info']['location'] }}{{
                                                        invoice_item['subject_info']['phone'] }}
                                                </div>
                                            </div>

                                        </li>
                                        <li class="khh_txt">
                                            <label class="khh_txt_title">开户行及账号：</label><span
                                                class="f-small2-1 color_text">
                                                -- </span>
                                        </li>
                                    </ul> -->
                                    <div class="beizhu">


                                        <div class="password">备注</div>
                                        <div class="remarks_invoice">
                                            <div v-if="invoice_item['total_deduction'] > 0">
                                                扣除额：{{ invoice_item['total_deduction'] }}
                                            </div>
                                            <div>
                                                {{
                                                    invoice_item['piaomian_remarks'] }}</div>
                                        </div>
                                    </div>


                                </div>
                            </div>

                        </div>
                        <!-- invoice body start -->
                        <ul class="invoicetFooter color_text">
                            <li>
                                <label>开票人：</label><span style="color:#ccc"></span>
                            </li>
                            <li>
                                <label></label><span></span>
                            </li>
                            <li>
                                <label></label><span></span>
                            </li>
                            <li>
                                <span class="audit_id"> {{ invoice_item.audit_id }}
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>

            </CarouselItem>

        </Carousel>
    </div>
</template>

<script>
import { http } from "@/utils/http.js";

export default {
    components: {

    },
    props: [],
    name: "invoice_template",
    data() {
        return {
            carousel_value: 0,
            window_width: 0,
            window_height: 0,
            money_upper_str: "",
            invoice_index: 0,
            subject_dict: {},


            bank_info: {

            },

            subject_info: {

            },

            project_subject_info: {
                company_name: '',
                tax_num: '',
                company_place: '',
                company_phone: '',
                back_name: '',
                back_num: ''
            },

            invoice_list: [],
            main_show: false,

            del_show: true,
            hide_zeero_flag: false

        }
    },
    mounted() {
        this.get_invoice_subject_dict()
    },

    methods: {

        open(invoice_list, del_show) {
            this.invoice_list = invoice_list
            this.main_show = false
            this.main_show = true
            this.del_show = del_show

        },


        add(template_invoice_list) {
            var _list = []
            for (var i = 0; i < template_invoice_list.length; i++) {
                var subject_id = template_invoice_list[i]['subject_id']
                var tax_rate_list = template_invoice_list[i]['tax_rate_list']


                var _dict = {
                    invoice_type: template_invoice_list[i]['invoice_type'],
                    total_money: 0,
                    total_tax_money: 0,
                    project_subject_info: {},
                    remarks: '--',
                    tax_rate_list: tax_rate_list,
                    subject_info: this.subject_dict[subject_id],
                    piaomian_remarks: template_invoice_list[i]['piaomian_remarks']
                }
                // 计算总金额 
                var total_money = 0
                for (var invocie_index = 0; invocie_index < tax_rate_list.length; invocie_index++) {
                    var money = tax_rate_list[invocie_index]['money']
                    console.log(money)
                    total_money += parseFloat(money);
                    console.log(total_money)
                }
                _dict['total_money'] = total_money.toFixed(2)

                // 计算总价款 
                var total_price = 0
                for (var invocie_index = 0; invocie_index < tax_rate_list.length; invocie_index++) {
                    let _price = tax_rate_list[invocie_index]['price']
                    total_price += parseFloat(_price);
                }
                _dict['total_price'] = total_price.toFixed(2)

                // 计算总税额
                var total_tax = 0
                for (var invocie_index = 0; invocie_index < tax_rate_list.length; invocie_index++) {
                    let _tax = tax_rate_list[invocie_index]['tax']
                    total_tax += parseFloat(_tax);
                }
                _dict['total_tax'] = total_tax.toFixed(2)

                // 计算总的免税扣除额
                var invoice_deduction = 0
                for (var invocie_index = 0; invocie_index < tax_rate_list.length; invocie_index++) {
                    let _deduction = tax_rate_list[invocie_index]['deduction']
                    invoice_deduction += parseFloat(_deduction);
                }
                _dict['total_deduction'] = invoice_deduction.toFixed(2)

                // 项目信息
                var invoice_data = template_invoice_list[i]['invoice_data']
                if (invoice_data.length > 0) {
                    _dict['project_subject_info'] = invoice_data[0]
                }


                _list.push(_dict)

            }
            this.invoice_list = _list
            this.main_show = false
            this.main_show = true

        },

        click_del(index) {
            var that = this
            console.log(index)
            this.$Modal.confirm({
                title: '提示',
                content: '<p>确认删除这张发票吗？</p>',
                onOk: () => {
                    that.invoice_list.splice(index, 1)
                    that.main_show = false
                    that.main_show = true
                    that.$emit('del', index)
                    that.$Message.info('删除成功')
                },
                onCancel: () => {

                }
            });

        },

        //获取开票主体字典
        get_invoice_subject_dict() {

            var that = this
            var obj = {
            }
            http("post", process.env.VUE_APP_HOST + "/finance/invoice/subject_dict", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.subject_dict = res.data.subject_dict

                    } else {

                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });


                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })


        },

        tabs_change(e) {
            console.log(e)
        },


        rand_mima() {
            return String(this.getRandomSixDigit(4)) + '+' + String(this.getRandomSixDigit(15)) + '+0*13>3>0<><22908-+<+03*<-84>40><3<64-076746-2+2082*9112+' + String(this.getRandomSixDigit(6)) + ' /07-228<135701+4 />039*' + String(this.getRandomSixDigit(8))
        },

        getRandomSixDigit(num) {
            let code = ''
            for (var i = 0; i < num; i++) {
                code += parseInt(Math.random() * 10)
            }

            return code
        },

        changeToChinese(Num) {
            //判断如果传递进来的不是字符的话转换为字符
            if (typeof Num == "number") {
                Num = new String(Num);
            };
            Num = Num.replace(/,/g, "") //替换tomoney()中的“,”
            Num = Num.replace(/ /g, "") //替换tomoney()中的空格
            Num = Num.replace(/￥/g, "") //替换掉可能出现的￥字符
            if (isNaN(Num)) { //验证输入的字符是否为数字
                //alert("请检查小写金额是否正确");
                return "";
            };
            //字符处理完毕后开始转换，采用前后两部分分别转换
            var part = String(Num).split(".");
            var newchar = "";
            //小数点前进行转化
            for (var i = part[0].length - 1; i >= 0; i--) {
                if (part[0].length > 10) {
                    return "";
                    //若数量超过拾亿单位，提示
                }
                var tmpnewchar = ""
                var perchar = part[0].charAt(i);
                switch (perchar) {
                    case "0":
                        tmpnewchar = "零" + tmpnewchar;
                        break;
                    case "1":
                        tmpnewchar = "壹" + tmpnewchar;
                        break;
                    case "2":
                        tmpnewchar = "贰" + tmpnewchar;
                        break;
                    case "3":
                        tmpnewchar = "叁" + tmpnewchar;
                        break;
                    case "4":
                        tmpnewchar = "肆" + tmpnewchar;
                        break;
                    case "5":
                        tmpnewchar = "伍" + tmpnewchar;
                        break;
                    case "6":
                        tmpnewchar = "陆" + tmpnewchar;
                        break;
                    case "7":
                        tmpnewchar = "柒" + tmpnewchar;
                        break;
                    case "8":
                        tmpnewchar = "捌" + tmpnewchar;
                        break;
                    case "9":
                        tmpnewchar = "玖" + tmpnewchar;
                        break;
                }
                switch (part[0].length - i - 1) {
                    case 0:
                        tmpnewchar = tmpnewchar + "元";
                        break;
                    case 1:
                        if (perchar != 0) tmpnewchar = tmpnewchar + "拾";
                        break;
                    case 2:
                        if (perchar != 0) tmpnewchar = tmpnewchar + "佰";
                        break;
                    case 3:
                        if (perchar != 0) tmpnewchar = tmpnewchar + "仟";
                        break;
                    case 4:
                        tmpnewchar = tmpnewchar + "万";
                        break;
                    case 5:
                        if (perchar != 0) tmpnewchar = tmpnewchar + "拾";
                        break;
                    case 6:
                        if (perchar != 0) tmpnewchar = tmpnewchar + "佰";
                        break;
                    case 7:
                        if (perchar != 0) tmpnewchar = tmpnewchar + "仟";
                        break;
                    case 8:
                        tmpnewchar = tmpnewchar + "亿";
                        break;
                    case 9:
                        tmpnewchar = tmpnewchar + "拾";
                        break;
                }
                var newchar = tmpnewchar + newchar;
            }
            //小数点之后进行转化
            if (Num.indexOf(".") != -1) {
                if (part[1].length > 2) {
                    // alert("小数点之后只能保留两位,系统将自动截断");
                    part[1] = part[1].substr(0, 2)
                }
                for (i = 0; i < part[1].length; i++) {
                    tmpnewchar = ""
                    perchar = part[1].charAt(i)
                    switch (perchar) {
                        case "0":
                            tmpnewchar = "零" + tmpnewchar;
                            break;
                        case "1":
                            tmpnewchar = "壹" + tmpnewchar;
                            break;
                        case "2":
                            tmpnewchar = "贰" + tmpnewchar;
                            break;
                        case "3":
                            tmpnewchar = "叁" + tmpnewchar;
                            break;
                        case "4":
                            tmpnewchar = "肆" + tmpnewchar;
                            break;
                        case "5":
                            tmpnewchar = "伍" + tmpnewchar;
                            break;
                        case "6":
                            tmpnewchar = "陆" + tmpnewchar;
                            break;
                        case "7":
                            tmpnewchar = "柒" + tmpnewchar;
                            break;
                        case "8":
                            tmpnewchar = "捌" + tmpnewchar;
                            break;
                        case "9":
                            tmpnewchar = "玖" + tmpnewchar;
                            break;
                    }
                    if (i == 0) tmpnewchar = tmpnewchar + "角";
                    if (i == 1) tmpnewchar = tmpnewchar + "分";
                    newchar = newchar + tmpnewchar;
                }
            }
            //替换所有无用汉字
            while (newchar.search("零零") != -1)
                newchar = newchar.replace("零零", "零");
            newchar = newchar.replace("零亿", "亿");
            newchar = newchar.replace("亿万", "亿");
            newchar = newchar.replace("零万", "万");
            newchar = newchar.replace("零元", "元");
            newchar = newchar.replace("零角", "");
            newchar = newchar.replace("零分", "");
            if (newchar.charAt(newchar.length - 1) == "元") {
                newchar = newchar + "整"
            }
            return newchar;

        },



    },





};
</script>

<style scoped>
.beizhu{
    display: flex;
    align-items: center;
}

.audit_id {
    color: #878787;
    -webkit-user-select: text !important;
    -moz-user-select: text !important;
    -ms-user-select: text !important;
    user-select: text !important;
}

.qrcode_template {
    width: 100px;
    height: 100px;
    border: 1px dashed hsl(0, 0%, 63%);
    color: #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
}

.zuofei_icon {
    font-size: 170px;
    position: absolute;
    right: 10px;
    top: -50px;
    color: #ff3133;
    opacity: .7;

}

.del_icon {
    position: absolute;
    right: 0px;
    padding: 3px 10px;
    font-size: 12px;
    background-color: #ff3133;
    border-radius: 0 0 0 5px;
    top: 0px;
    cursor: pointer;
    color: #fff;
}

.khh_txt_title {
    width: 100px;
    flex-shrink: 0;
    color: #b29999;
}

.khh_txt {
    display: flex;
}

.remarks_invoice {
    color: #0466dd;
    font-size: 12px;
    padding: 5px 10px;

}

.zhang_img {
    position: absolute;
    z-index: 1;
    top: -25px;
    left: 350px;
    opacity: 1;
    width: 180px;
}

.hedaer_title {
    font-size: 28px;
    color: #000000;
    font-weight: 600;
}

.location_div {
    display: flex;
}

.goods_text {
    text-align: center;
    width: 100%;
    font-size: 12px;
}

/deep/ .el-tabs--border-card>.el-tabs__content {
    padding: 0px;
}

/deep/ .el-tabs--border-card {
    box-shadow: none;
    border-bottom: none
}

.main2 {
    background-color: #fff;
    margin: 0;
    padding: 0 0 0 10px;
    position: relative;

    /* transform: scale(0.8, 0.8); */

}

.noid {
    font-size: 20px;
    font-weight: 600;
    padding-bottom: 20px;
    padding-right: 20px;
}

.fapiaohao {
    padding-bottom: 10px;
    color: #ff3133;
    font-size: 20px;
}

.jiqima {
    font-size: 13px;
    padding-left: 10px;
}


ul,
ul li {
    list-style: none;
    margin: 0;
    padding: 0;
}

body {
    font-family: 'simsun';
}

label {
    color: #333333;
}

.rmb2 {
    font-size: 14px;
    color: #0466dd;
    margin-right: 20px;
}

.color_text {
    color: #0466dd;
}

.rmb {
    color: #0466dd;
    font-family: Arial, Helvetica, sans-serif;
}

.c-red {
    color: #ff3133;
    margin-left: 10px;
    font-size: 20px;
    font-weight: 400;
}




.f-big {
    font-size: 12px;
}

.f-small {
    font-size: 12px;
}

.f-small2 {
    font-size: 10px;
}


.location_title {
    width: 100px;
    flex-shrink: 0;
    color: #b29999
}

.f-small2-1 {
    /* width: 313px; */
    font-size: 10px;
    height: 25px;
    display: flex;
    align-items: center;
    line-height: 10px;
}

.invoicMain_box {
    display: flex;
    justify-content: center;
}

.invoicMain {
    position: relative;
    transform: scale(0.9, 0.9);
    background-color: #fff;
    float: left;
    width: 920px;
    /* margin: 0 auto; */
    margin-bottom: 15px;
    font-size: 14px;
    color: #000;
    padding: 20px 10px 15px 10px;
    border-top: 1px solid #a94f4f;
    border-bottom: 1px solid #a94f4f;
    border-left: 1px solid #a94f4f;
    border-right: 1px solid #a94f4f;
    margin-left: 10px;
    margin-right: 10px;
}

.toptip {
    text-align: center;
    padding-top: 4px;
    height: 20px;
}

.invoiceHeader {
    height: 108px;
    margin-bottom: 5px;
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    position: relative;
}

.headerLeft {
    width: 300px;
    display: flex;
}

/* .headerLeft div:nth-child(1) {
    width: 85px;
    line-height: 26px;
} */

.headerLeft div p {
    line-height: 26px;
}

.headerLeft div:nth-child(2) p.c-red {
    width: 170px;
    height: 46px;
    text-align: center;
    line-height: 42px;
    font-size: 24px;
    letter-spacing: 2px;
}

.headerLeft div p.c span {
    font-size: 18px;
    letter-spacing: 1px;
}

.headerRight {
    padding-left: 58px;
    width: 316px;
}

.headerRight p:nth-child(1) {
    font-size: 24px;
}

.headerRight p:nth-child(1) strong {
    font-family: 'LiSu';
    font-size: 30px;
    padding-right: 20px;
}

.fapiaohaoma {
    font-size: 13px;
    color: #292929;
}

.fapiaohaoma_span {
    font-size: 13px;
    color: #ccc;
}

.headerRight p:nth-child(2) {
    text-align: left;
    margin-top: -5px;
}

.headerRight p:nth-child(3) {
    text-align: right;
    font-size: 18px;
    letter-spacing: 1px;
}

.headerRight p:nth-child(4) {
    text-align: center;
    letter-spacing: 1px;
}

.headerMiddle {
    text-align: center;
    width: 300px;
    z-index: 999
}

.headerMiddle h1 {
    font-size: 32px;
    color: #2e2e2e;
    padding-bottom: 22px;
}

.total .rmb {
    font-size: 16px;
}

.line {
    height: 2px;
    border-top: #ccc 1px solid;
    border-bottom: #ccc 1px solid;
    margin-bottom: 30px;
}

.headerRight li {
    line-height: 24px;
}

.invoiceBody {
    border: 1px solid #ccc;
}

.userInfo {
    width: 100%;
    display: flex;
    align-items: center;
    height: 96px;
    border-bottom: 1px solid #ccc;
}

.userInfo ul {
    width: 50%;
    margin: 0 5px;
    padding: 10px 0;
}

.userInfo ul li {
    line-height: 24px;
}

.userInfo ul li:nth-child(2) .f-big {}

.userInfo ul li:nth-child(3) {
    position: relative;
}

.userInfo ul li .f-small2 {
    position: absolute;
    width: 120%;
    transform: scale(0.8);
    left: 44px;
}

.buy {
    width: 30px;
    border-right: 1px solid #ccc;
    padding: 0 10px;
    text-align: center;
    height: 100%;
    display: flex;
    align-items: center;
    color: #333333;
    line-height: 20px;
}

.password {
    width: 30px;
    padding: 0 10px;
    border-right: 1px solid #ccc;
    border-left: 1px solid #ccc;
    text-align: center;
    height: 100%;
    display: flex;
    align-items: center;
    color: #333333;
    line-height: 20px;
}

.pwdInfo {
    flex: 1;
    font-size: 15px;
    padding: 0 15px;
    height: 90px;
    padding-top: 10px;
    overflow: hidden;
    word-break: break-all;
    letter-spacing: 2px;
}

.goodsInfo {
    height: 210px;
    margin: 0;
    padding: 0;
}

.goodsInfo li {
    display: flex;
    color: #333333;
    text-align: center;
}

.name {
    width: 260px;
    border-right: 1px solid #ccc;
}

.spec {
    width: 140px;
    border-right: 1px solid #ccc;
}

.qty {
    width: 108px;
    border-right: 1px solid #ccc;
}

.unit,
.taxRate {
    width: 65px;
    border-right: 1px solid #ccc;
}

.qty,
.price {
    width: 160px;
    border-right: 1px solid #ccc;
}

.money {
    flex: 1;
    border-right: 1px solid #ccc;
}

.taxAmount {
    flex: 1;
}

.GoodsTable {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed
}

.GoodsTable td {
    border-right: 1px solid #ccc;
    color: #333333;
    padding: 0 4px;
}

.invoice-list td {
    color: #000;
    vertical-align: middle;
}

.invoice-list td:nth-child(5),
.invoice-list td:nth-child(6),
.invoice-list td:nth-child(7),
.invoice-list td:nth-child(8),
.total td:nth-child(5),
.total td:nth-child(6),
.total td:nth-child(7),
.total td:nth-child(8) {
    text-align: right;
}

.invoice-list {
    overflow: hidden;
    background-color: rgba(250, 248, 248, 0.974);



}

.invoice-list tr td {
    height: 21px;
}

.GoodsTable thead tr {
    height: 24px;
    text-align: center;
}

.GoodsTotal {
    height: 34px;
}

.GoodsTotal {
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
}

.total td {
    color: #000;
}

.total td:nth-child(1) {
    text-align: center;
    color: #333333;
}

.total td:nth-child(6),
.total td:nth-child(8) {
    font-size: 18px;
}

.invoicetFooter {
    padding-top: 2px;
    display: flex;
    justify-content: space-between;
    margin-bottom: -3px;
}

.invoicetFooter li {
    width: 25%;
}

.invoiceHeader-left {
    width: 67%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
</style>